export const services = [
  {
    slug: "music-distribution",
    title: "Music Distribution",
    desc: "Get your music on Spotify, Apple Music, Boomplay, Audiomack, YouTube Music, and 150+ platforms worldwide — fast, reliable, and built for African artists reaching global audiences.",
    price: "From ₦15,000",
    priceNote: "/ release",
    heroImage: "https://picsum.photos/seed/mu-service-distribution/500/500",
    whatsIncluded: [
      { title: "Global Platform Delivery", desc: "Spotify, Apple Music, Boomplay, Audiomack, YouTube Music, TikTok, and 150+ more." },
      { title: "Keep 100% of Your Rights", desc: "You own your masters and publishing — always. We just deliver it." },
      { title: "Monthly Royalty Payouts", desc: "Royalties collected from every platform, paid directly to your account." },
      { title: "Release Scheduling", desc: "Set a future release date and we handle the rest automatically." },
      { title: "Spotify for Artists Verification", desc: "We help you claim and verify your official artist profile." },
      { title: "Dedicated Support", desc: "A real person to help if anything goes wrong with your release." }
    ],
    howItWorks: [
      { title: "Upload Your Track", desc: "Submit your audio file and metadata — title, artist, genre, cover art." },
      { title: "We Review & Prepare", desc: "Our team checks quality and formatting before it goes out to platforms." },
      { title: "Goes Live Everywhere", desc: "Your release appears across all 150+ platforms on your chosen date." },
      { title: "Track Your Royalties", desc: "Monitor streams and earnings in one place from your Artist Dashboard." }
    ],
    pricingHeadline: "Pay Per Release or Go Unlimited",
    pricingOptions: [
      { name: "Single Release", price: "₦1,529", period: "one-time", badge: null,
        features: ["1 track", "150+ platforms", "Keep 100% rights", "Monthly payouts"] },
      { name: "EP / Album", price: "₦1,529", period: "one-time", badge: "Best Value",
        features: ["Up to 6 tracks", "150+ platforms", "Keep 100% rights", "Priority review"] },
      { name: "Unlimited", price: "₦1,529", period: "year", badge: null,
        features: ["Unlimited releases", "150+ platforms", "Keep 100% rights", "Dedicated support"] }
    ],
    faqHeading: "Distribution FAQ",
    faq: [
      { q: "Do I keep my rights?", a: "Yes — 100% of your masters and publishing stay with you, always." },
      { q: "How fast is my release?", a: "Standard releases go live in 3-5 business days. Scheduled releases go live on your chosen date." },
      { q: "Which platforms are supported?", a: "Spotify, Apple Music, Boomplay, Audiomack, YouTube Music, TikTok, Deezer, Amazon Music, and 150+ more." },
      { q: "Can I schedule a release date?", a: "Yes, all plans include free release scheduling up to 12 months in advance." }
    ]
  },
  {
    slug: "music-promotion",
    title: "Music Promotion",
    desc: "Targeted ad campaigns and influencer seeding to put your track in front of real, engaged listeners who already stream artists like you.",
    price: "From ₦15,000",
    priceNote: "/ campaign",
    heroImage: "https://picsum.photos/seed/mu-service-promotion/500/500",
    whatsIncluded: [
      { title: "Targeted Ad Campaigns", desc: "Instagram, TikTok, and YouTube ads matched to your target audience." },
      { title: "Influencer Seeding", desc: "Your track placed with creators active in your genre and market." },
      { title: "Campaign Performance Reports", desc: "Full breakdown of reach, engagement, and streams driven." },
      { title: "Genre-Matched Targeting", desc: "Ads shown to listeners who already stream artists like you." },
      { title: "Short-Form Content Ideas", desc: "Ready-to-post clip concepts built around your release." },
      { title: "Dedicated Support", desc: "A campaign manager to help you get the most from your budget." }
    ],
    howItWorks: [
      { title: "Share Your Track", desc: "Send us the track and your campaign goals." },
      { title: "We Build Your Campaign", desc: "Audience targeting, budget, and creative are set up for you." },
      { title: "Campaign Goes Live", desc: "Ads and influencer seeding run across your chosen platforms." },
      { title: "Review Your Results", desc: "See streams, reach, and engagement in your campaign report." }
    ],
    pricingHeadline: "Pay Per Campaign or Stay Always-On",
    pricingOptions: [
      { name: "Single Campaign", price: "₦15,000", period: "one-time", badge: null,
        features: ["1 track", "7-day campaign", "Performance report", "Email support"] },
      { name: "Extended Campaign", price: "₦25,000", period: "one-time", badge: "Best Value",
        features: ["Up to 3 tracks", "30-day campaign", "Influencer seeding", "Priority support"] },
      { name: "Always-On", price: "₦45,000", period: "month", badge: null,
        features: ["Unlimited tracks", "Ongoing campaigns", "Dedicated manager", "Monthly reporting"] }
    ],
    faqHeading: "Promotion FAQ",
    faq: [
      { q: "How is my audience targeted?", a: "Ads are matched to listeners who already stream artists in your genre and market." },
      { q: "How long does a campaign run?", a: "Campaigns run from 7 to 30 days depending on your plan, with reporting throughout." },
      { q: "Do I need existing content?", a: "No — we can put together short-form content ideas built around your release." },
      { q: "Can I change my budget mid-campaign?", a: "Yes, reach out to your campaign manager any time to adjust your spend." }
    ]
  },
  {
    slug: "playlist-pitching",
    title: "Playlist Pitching",
    desc: "Direct pitching to curators across editorial and independent playlists in your genre, ahead of your release date.",
    price: "From ₦15,000",
    priceNote: "/ track",
    heroImage: "https://picsum.photos/seed/mu-service-pitching/500/500",
    whatsIncluded: [
      { title: "Curator Network Access", desc: "Pitched directly to editorial and independent curators in your genre." },
      { title: "Genre-Matched Pitching", desc: "Your track only goes to playlists that fit its sound." },
      { title: "Placement Reporting", desc: "See exactly which playlists accepted your track." },
      { title: "Pre-Release Pitching", desc: "Submit ahead of your release date for the best placement odds." },
      { title: "Unlimited Resubmissions", desc: "Didn't land a spot? We pitch your next single too." },
      { title: "Dedicated Support", desc: "A real person reviewing every pitch, not an algorithm." }
    ],
    howItWorks: [
      { title: "Submit Your Track", desc: "Share your track, genre, and release date." },
      { title: "We Match Curators", desc: "Your track is matched to relevant playlist curators." },
      { title: "Pitches Go Out", desc: "We reach out directly ahead of your release date." },
      { title: "Track Placements", desc: "See which playlists picked up your track and how it's performing." }
    ],
    pricingHeadline: "Pay Per Track or Pitch Every Release",
    pricingOptions: [
      { name: "Single Pitch", price: "₦15,000", period: "one-time", badge: null,
        features: ["1 track", "10 curators", "Placement report", "Email support"] },
      { name: "Priority Pitch", price: "₦25,000", period: "one-time", badge: "Best Value",
        features: ["1 track", "30+ curators", "Pre-release pitching", "Priority support"] },
      { name: "Ongoing", price: "₦45,000", period: "month", badge: null,
        features: ["Unlimited tracks", "30+ curators", "Resubmissions included", "Dedicated support"] }
    ],
    faqHeading: "Playlist Pitching FAQ",
    faq: [
      { q: "How many curators will see my track?", a: "Between 10 and 30+ curators depending on your plan, all matched to your genre." },
      { q: "When should I submit?", a: "Ideally 2-3 weeks ahead of your release date for the best placement odds." },
      { q: "What happens if I don't land a placement?", a: "Priority and Ongoing plans include resubmissions for your next single at no extra cost." },
      { q: "Can I see which playlists picked up my track?", a: "Yes — every pitch includes a placement report showing exactly where your track landed." }
    ]
  },
  {
    slug: "press-pr",
    title: "Press & PR",
    desc: "Professional press coverage, blog features, and a media-ready press kit to build credibility with fans and industry contacts.",
    price: "From ₦15,000",
    priceNote: "/ package",
    heroImage: "https://picsum.photos/seed/mu-service-press/500/500",
    whatsIncluded: [
      { title: "Press Release Writing", desc: "A professional release written and edited for you." },
      { title: "Media Outreach", desc: "Sent directly to entertainment blogs and outlets in your market." },
      { title: "Media-Ready EPK", desc: "A downloadable press kit ready to share with journalists." },
      { title: "Feature Placement Support", desc: "We follow up to help secure interviews and features." },
      { title: "Coverage Report", desc: "A summary of where your story ran and what it reached." },
      { title: "Dedicated Support", desc: "A real contact managing your outreach from start to finish." }
    ],
    howItWorks: [
      { title: "Share Your Story", desc: "Tell us about the release, the artist, and the angle." },
      { title: "We Build Your Kit", desc: "Press release and EPK are written and designed for you." },
      { title: "Outreach Goes Out", desc: "Your story is pitched to relevant blogs and outlets." },
      { title: "Track Your Coverage", desc: "See where your story ran and how it performed." }
    ],
    pricingHeadline: "Pay Per Story or Run PR All Year",
    pricingOptions: [
      { name: "Single Story", price: "₦15,000", period: "one-time", badge: null,
        features: ["1 press release", "EPK included", "10 outlets", "Email support"] },
      { name: "Feature Package", price: "₦25,000", period: "one-time", badge: "Best Value",
        features: ["Press release + EPK", "30+ outlets", "Interview support", "Priority support"] },
      { name: "Ongoing PR", price: "₦45,000", period: "month", badge: null,
        features: ["Unlimited stories", "Outreach every release", "Dedicated support", "Monthly reporting"] }
    ],
    faqHeading: "Press & PR FAQ",
    faq: [
      { q: "What's included in the EPK?", a: "A media-ready press kit with your bio, photos, music links, and achievements, formatted for journalists." },
      { q: "How many outlets will my story reach?", a: "Between 10 and 30+ outlets depending on your plan, matched to your genre and market." },
      { q: "Can you help secure interviews?", a: "Yes — Feature Package and Ongoing PR both include follow-up support to help land interviews." },
      { q: "Will I see where my story ran?", a: "Every package includes a coverage report showing where your story was picked up." }
    ]
  },
  {
    slug: "social-campaigns",
    title: "Social Media Campaigns",
    desc: "Custom short-form content and paid social strategy tailored to your release timeline, across every platform that matters.",
    price: "From ₦15,000",
    priceNote: "/ month",
    heroImage: "https://picsum.photos/seed/mu-service-social/500/500",
    whatsIncluded: [
      { title: "Content Calendar", desc: "A posting plan built around your release timeline." },
      { title: "Short-Form Video Concepts", desc: "Ready-to-shoot ideas for Reels, TikTok, and Shorts." },
      { title: "Paid Social Boosting", desc: "Your best-performing posts backed with ad spend." },
      { title: "Platform-Specific Strategy", desc: "Content tailored to how each platform actually performs." },
      { title: "Performance Tracking", desc: "See what's working and what to double down on." },
      { title: "Dedicated Support", desc: "A social strategist you can reach throughout your campaign." }
    ],
    howItWorks: [
      { title: "Share Your Release Plan", desc: "Tell us your release date and content you already have." },
      { title: "We Build Your Calendar", desc: "A content plan and concepts tailored to your timeline." },
      { title: "Content Goes Live", desc: "Posts go out on schedule, boosted where it counts." },
      { title: "Review Performance", desc: "See reach, engagement, and growth in your report." }
    ],
    pricingHeadline: "Pay Per Release or Stay Always-On",
    pricingOptions: [
      { name: "Single Release", price: "₦15,000", period: "one-time", badge: null,
        features: ["2 weeks of content", "1 platform", "Basic boosting", "Email support"] },
      { name: "Full Campaign", price: "₦25,000", period: "one-time", badge: "Best Value",
        features: ["4 weeks of content", "3 platforms", "Paid boosting included", "Priority support"] },
      { name: "Always-On", price: "₦45,000", period: "month", badge: null,
        features: ["Ongoing content", "All platforms", "Continuous boosting", "Dedicated strategist"] }
    ],
    faqHeading: "Social Campaigns FAQ",
    faq: [
      { q: "Which platforms do you cover?", a: "Instagram, TikTok, and YouTube Shorts, with strategy tailored to how each one performs." },
      { q: "Do you create the content or just boost it?", a: "Both — we build short-form concepts for you and back the best-performing posts with ad spend." },
      { q: "How much content do I get?", a: "From 2 weeks of content on the Single Release plan up to a fully ongoing calendar on Always-On." },
      { q: "Can I track performance?", a: "Yes, every plan includes performance tracking so you can see what's working." }
    ]
  }
];

export function getServiceBySlug(slug) {
  return services.find((s) => s.slug === slug);
}

export const servicesFaq = [
  { q: "How long does music distribution take?", a: "Most releases go live on all platforms within 3-5 business days of approval." },
  { q: "Can I upgrade my plan later?", a: "Yes, you can upgrade or add services anytime from your Artist Dashboard — no long-term lock-in." },
  { q: "Do you guarantee playlist placement?", a: "We guarantee pitching to relevant curators, but placement itself is never guaranteed by any platform or service." },
  { q: "What genres do you support?", a: "All genres — with deep experience in Afrobeats, Amapiano, R&B, Hip-Hop, and Gospel." },
  { q: "How do I get paid from streams?", a: "Royalties are collected from all platforms and paid out monthly directly to your linked account." }
];

export const plans = [
  {
    name: "Starter",
    price: "₦15,000",
    period: "month",
    popular: false,
    features: ["1 track distribution", "Basic playlist pitching", "Email support"]
  },
  {
    name: "Growth",
    price: "₦25,000",
    period: "month",
    popular: true,
    features: [
      "3 track distribution",
      "Promotion campaign included",
      "Priority playlist pitching",
      "Chat support"
    ]
  },
  {
    name: "Pro",
    price: "₦45,000",
    period: "month",
    popular: false,
    features: [
      "Unlimited distribution",
      "Full promotion + PR package",
      "Social media campaigns",
      "Dedicated account manager"
    ]
  }
];
